module.exports = __webpack_public_path__ + "static/media/Picto_DockSheet_valid.55171184.png";